import { render, staticRenderFns } from "./UpdateMyCourse.vue?vue&type=template&id=c5db5208&scoped=true&"
import script from "./UpdateMyCourse.vue?vue&type=script&lang=js&"
export * from "./UpdateMyCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5db5208",
  null
  
)

export default component.exports